import { SxProps } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC, useState } from 'react';
import { SearchBoxContainer } from '@components/search';
import SearchBox from '@components/search/SearchBox';

interface CitationSearchProps {
    setSearchValue: (value: string) => void;
}

const containerSx: SxProps = {
    border: 1,
    borderColor: 'grey.500',
    boxShadow: 'none',
    mb: 2,
    mt: 1,
};

const CitationSearch: FC<CitationSearchProps> = ({ setSearchValue }) => {
    const { t } = useTranslation('common');
    const [inputValue, setInputValue] = useState<string>('');

    return (
        <SearchBoxContainer sx={containerSx}>
            <SearchBox
                onChange={(newValue) => setInputValue(newValue || '')}
                onSearch={() => setSearchValue(inputValue)}
                placeholder={t('citations.search.placeholder')}
                value={inputValue}
            />
        </SearchBoxContainer>
    );
};

export default CitationSearch;
